/*
 * @Author: bbqin
 * @Date: 2022-08-02 11:15:24
 * @LastEditTime: 2022-08-25 10:34:25
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\adapters\api.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
// import React from 'react';
import { getCacheExtendJson, analysisPageEventExtend } from '../model/free';
import * as constant from '../const';
// import { ViewModel } from '@platform/api';

const ModuleCacheName = constant.moduleCacheName;

const apiExtend = (name, params) => {
    let data = null;
    let freeExtendCacheJson = getCacheExtendJson();
    if (freeExtendCacheJson) {
        data = analysisPageEventExtend(freeExtendCacheJson, name, this, undefined, params);
    } else if (window.ViewModel) {
        let extendCache = window.ViewModel?.getData(ModuleCacheName);
        if (extendCache) {
            for (let pop in extendCache) {
                if (extendCache[pop] && extendCache[pop][name]) {
                    data = extendCache[pop][name](params);
                }
            }
        }
    }
    return data;
};
export default apiExtend;